import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class FeatureMedia extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    this.revision = 0;
    document.addEventListener(StandardEvents.productSelect, this.updateImages, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.abort?.abort();
    this.revision++;
  }

  updateImages = async (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest('dialog, product-card, quick-add-component')) return;
    if (target.closest('variant-picker')?.dataset.productId !== this.dataset.productId) return;
    const revision = ++this.revision;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || revision !== this.revision || !detail?.resource?.id) return;
      if (String(detail.productId) !== this.dataset.productId) return;
      const incoming = detail.html?.querySelector(`wb-feature-media[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`);
      if (!incoming) return;
      const changes = [];
      for (const image of this.querySelectorAll('img[data-feature-slot]')) {
        const replacement = incoming.querySelector(`img[data-feature-slot="${CSS.escape(image.dataset.featureSlot)}"]`);
        if (!replacement) return;
        changes.push([image, replacement]);
      }
      // Reuse the hero's response, preserving lazy loading and avoiding requests for every color.
      for (const [image, replacement] of changes) {
        for (const name of ['alt', 'width', 'height', 'sizes', 'srcset', 'src']) {
          const value = replacement.getAttribute(name);
          if (value === null) image.removeAttribute(name);
          else if (image.getAttribute(name) !== value) image.setAttribute(name, value);
        }
      }
      this.dataset.variantId = String(detail.resource.id);
      this.dataset.imageSet = incoming.dataset.imageSet || '';
    } catch {
      // Aborted hero selections retain the last complete set until the next selection resolves.
    }
  };
}

if (!customElements.get('wb-feature-media')) customElements.define('wb-feature-media', FeatureMedia);
